import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "옵션 개요",
  "description": "Turborepo의 플래그, 구성 및 시스템 환경 변수"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "turbo 호출의 동작을 관리하는 세 가지 방법이 있습니다:"
  }, {
    "heading": "",
    "content": "turbo.json의 구성"
  }, {
    "heading": "",
    "content": "시스템 환경 변수"
  }, {
    "heading": "",
    "content": "CLI 호출에 전달되는 플래그"
  }, {
    "heading": "",
    "content": "위에 나열된 세 가지 전략은 우선순위 순서로 되어 있습니다. 플래그 값이 제공되면 동일한 시스템 환경 변수 또는 turbo.json 구성이 있더라도 플래그 값이 사용됩니다. 따라서 다음을 권장합니다:"
  }, {
    "heading": "",
    "content": "turbo.json 구성은 기본값으로 사용"
  }, {
    "heading": "",
    "content": "시스템 환경 변수는 환경별 재정의에 사용"
  }, {
    "heading": "",
    "content": "플래그는 호출별 재정의에 사용"
  }, {
    "heading": "캐싱",
    "content": "동작"
  }, {
    "heading": "캐싱",
    "content": "플래그"
  }, {
    "heading": "캐싱",
    "content": "환경 변수"
  }, {
    "heading": "캐싱",
    "content": "turbo.json"
  }, {
    "heading": "캐싱",
    "content": "태스크 강제 실행"
  }, {
    "heading": "캐싱",
    "content": "--force"
  }, {
    "heading": "캐싱",
    "content": "TURBO_FORCE"
  }, {
    "heading": "캐싱",
    "content": "cache"
  }, {
    "heading": "캐싱",
    "content": "Remote Cache 타임아웃"
  }, {
    "heading": "캐싱",
    "content": "--remote-cache-timeout"
  }, {
    "heading": "캐싱",
    "content": "TURBO_REMOTE_CACHE_TIMEOUT"
  }, {
    "heading": "캐싱",
    "content": "remoteCache.timeout"
  }, {
    "heading": "캐싱",
    "content": "Remote Cache 업로드 타임아웃"
  }, {
    "heading": "캐싱",
    "content": "-"
  }, {
    "heading": "캐싱",
    "content": "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
  }, {
    "heading": "캐싱",
    "content": "remoteCache.uploadTimeout"
  }, {
    "heading": "캐싱",
    "content": "캐시 서명 키"
  }, {
    "heading": "캐싱",
    "content": "-"
  }, {
    "heading": "캐싱",
    "content": "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
  }, {
    "heading": "캐싱",
    "content": "signature"
  }, {
    "heading": "캐싱",
    "content": "Preflight 요청"
  }, {
    "heading": "캐싱",
    "content": "--preflight"
  }, {
    "heading": "캐싱",
    "content": "TURBO_PREFLIGHT"
  }, {
    "heading": "캐싱",
    "content": "remoteCache.preflight"
  }, {
    "heading": "캐싱",
    "content": "Remote Cache 기본 URL"
  }, {
    "heading": "캐싱",
    "content": "-"
  }, {
    "heading": "캐싱",
    "content": "TURBO_API"
  }, {
    "heading": "캐싱",
    "content": "remoteCache.apiUrl"
  }, {
    "heading": "캐싱",
    "content": "캐시 소스"
  }, {
    "heading": "캐싱",
    "content": "--cache"
  }, {
    "heading": "캐싱",
    "content": "TURBO_CACHE"
  }, {
    "heading": "캐싱",
    "content": "-"
  }, {
    "heading": "캐싱",
    "content": "로컬 캐시 디렉토리"
  }, {
    "heading": "캐싱",
    "content": "--cache-dir"
  }, {
    "heading": "캐싱",
    "content": "TURBO_CACHE_DIR"
  }, {
    "heading": "캐싱",
    "content": "cacheDir"
  }, {
    "heading": "메시지",
    "content": "동작"
  }, {
    "heading": "메시지",
    "content": "플래그"
  }, {
    "heading": "메시지",
    "content": "환경 변수"
  }, {
    "heading": "메시지",
    "content": "turbo.json"
  }, {
    "heading": "메시지",
    "content": "버전 출력 비활성화"
  }, {
    "heading": "메시지",
    "content": "-"
  }, {
    "heading": "메시지",
    "content": "TURBO_PRINT_VERSION_DISABLED"
  }, {
    "heading": "메시지",
    "content": "-"
  }, {
    "heading": "메시지",
    "content": "텔레메트리 메시지 비활성화"
  }, {
    "heading": "메시지",
    "content": "-"
  }, {
    "heading": "메시지",
    "content": "TURBO_TELEMETRY_MESSAGE_DISABLED"
  }, {
    "heading": "메시지",
    "content": "-"
  }, {
    "heading": "메시지",
    "content": "전역 turbo 경고 비활성화"
  }, {
    "heading": "메시지",
    "content": "-"
  }, {
    "heading": "메시지",
    "content": "TURBO_GLOBAL_WARNING_DISABLED"
  }, {
    "heading": "메시지",
    "content": "-"
  }, {
    "heading": "메시지",
    "content": "업데이트 알림 비활성화"
  }, {
    "heading": "메시지",
    "content": "-"
  }, {
    "heading": "메시지",
    "content": "TURBO_NO_UPDATE_NOTIFIER"
  }, {
    "heading": "메시지",
    "content": "noUpdateNotifier"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "동작"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "플래그"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "환경 변수"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "turbo.json"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "터미널 UI"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--ui"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "TURBO_UI"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "ui"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "영향받는 태스크 실행"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--affected"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "패키지 매니저 검사 비활성화"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--dangerously-disable-package-manager-check"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "dangerouslyDisablePackageManagerCheck"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "영향받는 base ref"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "TURBO_SCM_BASE"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "영향받는 head ref"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "TURBO_SCM_HEAD"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "직접 지정된 태스크만 실행"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--only"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "태스크 동시성"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--concurrency"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "TURBO_CONCURRENCY"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "태스크 로그 순서"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--log-order"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "TURBO_LOG_ORDER"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "현재 작업 디렉토리"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--cwd"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "스트리밍 로그 접두사"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--log-prefix"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "태스크 로그 출력 레벨"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--output-logs-option"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "outputLogs"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "전역 입력"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--global-deps"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "globalDependencies"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "터미널 색상"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "--color"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "FORCE_COLOR"
  }, {
    "heading": "태스크-실행-및-로그",
    "content": "-"
  }, {
    "heading": "환경-변수",
    "content": "동작"
  }, {
    "heading": "환경-변수",
    "content": "플래그"
  }, {
    "heading": "환경-변수",
    "content": "환경 변수"
  }, {
    "heading": "환경-변수",
    "content": "turbo.json"
  }, {
    "heading": "환경-변수",
    "content": "환경 변수 모드"
  }, {
    "heading": "환경-변수",
    "content": "--env-mode"
  }, {
    "heading": "환경-변수",
    "content": "-"
  }, {
    "heading": "환경-변수",
    "content": "envMode"
  }, {
    "heading": "환경-변수",
    "content": "벤더 환경 변수"
  }, {
    "heading": "환경-변수",
    "content": "-"
  }, {
    "heading": "환경-변수",
    "content": "TURBO_CI_VENDOR_ENV_KEY"
  }, {
    "heading": "환경-변수",
    "content": "-"
  }, {
    "heading": "환경-변수",
    "content": "프레임워크 변수 예외"
  }, {
    "heading": "환경-변수",
    "content": "--framework-inference"
  }, {
    "heading": "환경-변수",
    "content": "-"
  }, {
    "heading": "환경-변수",
    "content": "-"
  }, {
    "heading": "디버깅-출력",
    "content": "동작"
  }, {
    "heading": "디버깅-출력",
    "content": "플래그"
  }, {
    "heading": "디버깅-출력",
    "content": "환경 변수"
  }, {
    "heading": "디버깅-출력",
    "content": "turbo.json"
  }, {
    "heading": "디버깅-출력",
    "content": "실행 요약"
  }, {
    "heading": "디버깅-출력",
    "content": "--summarize"
  }, {
    "heading": "디버깅-출력",
    "content": "TURBO_RUN_SUMMARY"
  }, {
    "heading": "디버깅-출력",
    "content": "-"
  }, {
    "heading": "디버깅-출력",
    "content": "그래프 시각화"
  }, {
    "heading": "디버깅-출력",
    "content": "--graph"
  }, {
    "heading": "디버깅-출력",
    "content": "-"
  }, {
    "heading": "디버깅-출력",
    "content": "-"
  }, {
    "heading": "디버깅-출력",
    "content": "Dry run"
  }, {
    "heading": "디버깅-출력",
    "content": "--dry"
  }, {
    "heading": "디버깅-출력",
    "content": "-"
  }, {
    "heading": "디버깅-출력",
    "content": "-"
  }, {
    "heading": "인증",
    "content": "동작"
  }, {
    "heading": "인증",
    "content": "플래그"
  }, {
    "heading": "인증",
    "content": "환경 변수"
  }, {
    "heading": "인증",
    "content": "turbo.json"
  }, {
    "heading": "인증",
    "content": "로그인 URL"
  }, {
    "heading": "인증",
    "content": "-"
  }, {
    "heading": "인증",
    "content": "TURBO_LOGIN"
  }, {
    "heading": "인증",
    "content": "remoteCache.loginUrl"
  }, {
    "heading": "인증",
    "content": "팀 이름 (멀티 팀 Remote Cache용)"
  }, {
    "heading": "인증",
    "content": "--team"
  }, {
    "heading": "인증",
    "content": "TURBO_TEAM"
  }, {
    "heading": "인증",
    "content": "-"
  }, {
    "heading": "인증",
    "content": "팀 ID (멀티 팀 Remote Cache용)"
  }, {
    "heading": "인증",
    "content": "-"
  }, {
    "heading": "인증",
    "content": "TURBO_TEAMID"
  }, {
    "heading": "인증",
    "content": "-"
  }, {
    "heading": "인증",
    "content": "인증 토큰"
  }, {
    "heading": "인증",
    "content": "--token"
  }, {
    "heading": "인증",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "인증",
    "content": "-"
  }, {
    "heading": "기타",
    "content": "동작"
  }, {
    "heading": "기타",
    "content": "플래그"
  }, {
    "heading": "기타",
    "content": "환경 변수"
  }, {
    "heading": "기타",
    "content": "turbo.json"
  }, {
    "heading": "기타",
    "content": "바이너리 경로"
  }, {
    "heading": "기타",
    "content": "-"
  }, {
    "heading": "기타",
    "content": "TURBO_BINARY_PATH"
  }, {
    "heading": "기타",
    "content": "-"
  }, {
    "heading": "기타",
    "content": "로컬 turbo 다운로드"
  }, {
    "heading": "기타",
    "content": "-"
  }, {
    "heading": "기타",
    "content": "TURBO_DOWNLOAD_LOCAL_ENABLED"
  }, {
    "heading": "기타",
    "content": "-"
  }, {
    "heading": "기타",
    "content": "데몬"
  }, {
    "heading": "기타",
    "content": "--daemon / --no-daemon"
  }, {
    "heading": "기타",
    "content": "-"
  }, {
    "heading": "기타",
    "content": "daemon"
  }],
  "headings": [{
    "id": "옵션-표",
    "content": "옵션 표"
  }, {
    "id": "캐싱",
    "content": "캐싱"
  }, {
    "id": "메시지",
    "content": "메시지"
  }, {
    "id": "태스크-실행-및-로그",
    "content": "태스크 실행 및 로그"
  }, {
    "id": "환경-변수",
    "content": "환경 변수"
  }, {
    "id": "디버깅-출력",
    "content": "디버깅 출력"
  }, {
    "id": "인증",
    "content": "인증"
  }, {
    "id": "기타",
    "content": "기타"
  }]
};
export const toc = [{
  depth: 2,
  url: "#옵션-표",
  title: _jsx(_Fragment, {
    children: "옵션 표"
  })
}, {
  depth: 3,
  url: "#캐싱",
  title: _jsx(_Fragment, {
    children: "캐싱"
  })
}, {
  depth: 3,
  url: "#메시지",
  title: _jsx(_Fragment, {
    children: "메시지"
  })
}, {
  depth: 3,
  url: "#태스크-실행-및-로그",
  title: _jsx(_Fragment, {
    children: "태스크 실행 및 로그"
  })
}, {
  depth: 3,
  url: "#환경-변수",
  title: _jsx(_Fragment, {
    children: "환경 변수"
  })
}, {
  depth: 3,
  url: "#디버깅-출력",
  title: _jsx(_Fragment, {
    children: "디버깅 출력"
  })
}, {
  depth: 3,
  url: "#인증",
  title: _jsx(_Fragment, {
    children: "인증"
  })
}, {
  depth: 3,
  url: "#기타",
  title: _jsx(_Fragment, {
    children: "기타"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 호출의 동작을 관리하는 세 가지 방법이 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "/docs/reference/configuration",
          children: [_jsx(_components.code, {
            children: "turbo.json"
          }), "의 구성"]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: "시스템 환경 변수"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/run",
          children: "CLI 호출에 전달되는 플래그"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["위에 나열된 세 가지 전략은 우선순위 순서로 되어 있습니다. 플래그 값이 제공되면 동일한 시스템 환경 변수 또는 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 구성이 있더라도 플래그 값이 사용됩니다. 따라서 다음을 권장합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " 구성은 기본값으로 사용"]
      }), "\n", _jsx(_components.li, {
        children: "시스템 환경 변수는 환경별 재정의에 사용"
      }), "\n", _jsx(_components.li, {
        children: "플래그는 호출별 재정의에 사용"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "옵션-표",
      children: "옵션 표"
    }), "\n", _jsx(_components.h3, {
      id: "캐싱",
      children: "캐싱"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "동작"
            }), _jsx(_components.th, {
              children: "플래그"
            }), _jsx(_components.th, {
              children: "환경 변수"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "태스크 강제 실행"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--force",
                children: _jsx(_components.code, {
                  children: "--force"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_force",
                children: _jsx(_components.code, {
                  children: "TURBO_FORCE"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#cache",
                children: _jsx(_components.code, {
                  children: "cache"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Remote Cache 타임아웃"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#timeout",
                children: _jsx(_components.code, {
                  children: "--remote-cache-timeout"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_timeout",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_TIMEOUT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#timeout",
                children: _jsx(_components.code, {
                  children: "remoteCache.timeout"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Remote Cache 업로드 타임아웃"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_upload_timeout",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_UPLOAD_TIMEOUT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#uploadtimeout",
                children: _jsx(_components.code, {
                  children: "remoteCache.uploadTimeout"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "캐시 서명 키"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_remote_cache_signature_key",
                children: _jsx(_components.code, {
                  children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#signature",
                children: _jsx(_components.code, {
                  children: "signature"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Preflight 요청"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--preflight",
                children: _jsx(_components.code, {
                  children: "--preflight"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_preflight",
                children: _jsx(_components.code, {
                  children: "TURBO_PREFLIGHT"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#preflight",
                children: _jsx(_components.code, {
                  children: "remoteCache.preflight"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Remote Cache 기본 URL"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_api",
                children: _jsx(_components.code, {
                  children: "TURBO_API"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#remote-caching",
                children: _jsx(_components.code, {
                  children: "remoteCache.apiUrl"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "캐시 소스"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cache-options",
                children: _jsx(_components.code, {
                  children: "--cache"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_cache",
                children: _jsx(_components.code, {
                  children: "TURBO_CACHE"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "로컬 캐시 디렉토리"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cache-dir-path",
                children: _jsx(_components.code, {
                  children: "--cache-dir"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_cache_dir",
                children: _jsx(_components.code, {
                  children: "TURBO_CACHE_DIR"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#cachedir",
                children: _jsx(_components.code, {
                  children: "cacheDir"
                })
              })
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "메시지",
      children: "메시지"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "동작"
            }), _jsx(_components.th, {
              children: "플래그"
            }), _jsx(_components.th, {
              children: "환경 변수"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "버전 출력 비활성화"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_print_version_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_PRINT_VERSION_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "텔레메트리 메시지 비활성화"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_telemetry_message_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_TELEMETRY_MESSAGE_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["전역 ", _jsx(_components.code, {
                children: "turbo"
              }), " 경고 비활성화"]
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_global_warning_disabled",
                children: _jsx(_components.code, {
                  children: "TURBO_GLOBAL_WARNING_DISABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "업데이트 알림 비활성화"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_no_update_notifier",
                children: _jsx(_components.code, {
                  children: "TURBO_NO_UPDATE_NOTIFIER"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://turborepo.com/docs/reference/configuration#noupdatenotifier",
                children: _jsx(_components.code, {
                  children: "noUpdateNotifier"
                })
              })
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "태스크-실행-및-로그",
      children: "태스크 실행 및 로그"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "동작"
            }), _jsx(_components.th, {
              children: "플래그"
            }), _jsx(_components.th, {
              children: "환경 변수"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "터미널 UI"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--ui",
                children: _jsx(_components.code, {
                  children: "--ui"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_ui",
                children: _jsx(_components.code, {
                  children: "TURBO_UI"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#ui",
                children: _jsx(_components.code, {
                  children: "ui"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "영향받는 태스크 실행"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--affected",
                children: _jsx(_components.code, {
                  children: "--affected"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "패키지 매니저 검사 비활성화"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--dangerously-disable-package-manager-check",
                children: _jsx(_components.code, {
                  children: "--dangerously-disable-package-manager-check"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_dangerously_disable_package_manager_check",
                children: _jsx(_components.code, {
                  children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#dangerouslydisablepackagemanagercheck",
                children: _jsx(_components.code, {
                  children: "dangerouslyDisablePackageManagerCheck"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "영향받는 base ref"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_scm_base",
                children: _jsx(_components.code, {
                  children: "TURBO_SCM_BASE"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "영향받는 head ref"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_scm_head",
                children: _jsx(_components.code, {
                  children: "TURBO_SCM_HEAD"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "직접 지정된 태스크만 실행"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--only",
                children: _jsx(_components.code, {
                  children: "--only"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "태스크 동시성"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--concurrency-number--percentage",
                children: _jsx(_components.code, {
                  children: "--concurrency"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_concurrency",
                children: _jsx(_components.code, {
                  children: "TURBO_CONCURRENCY"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "태스크 로그 순서"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--log-order-option",
                children: _jsx(_components.code, {
                  children: "--log-order"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_log_order",
                children: _jsx(_components.code, {
                  children: "TURBO_LOG_ORDER"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "현재 작업 디렉토리"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--cwd-path",
                children: _jsx(_components.code, {
                  children: "--cwd"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "스트리밍 로그 접두사"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--log-prefix-option",
                children: _jsx(_components.code, {
                  children: "--log-prefix"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "태스크 로그 출력 레벨"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--output-logs-option",
                children: _jsx(_components.code, {
                  children: "--output-logs-option"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#outputlogs",
                children: _jsx(_components.code, {
                  children: "outputLogs"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "전역 입력"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--global-deps-file-glob",
                children: _jsx(_components.code, {
                  children: "--global-deps"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#globaldependencies",
                children: _jsx(_components.code, {
                  children: "globalDependencies"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "터미널 색상"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference#--color",
                children: _jsx(_components.code, {
                  children: "--color"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#force_color",
                children: "FORCE_COLOR"
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "환경-변수",
      children: "환경 변수"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "동작"
            }), _jsx(_components.th, {
              children: "플래그"
            }), _jsx(_components.th, {
              children: "환경 변수"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "환경 변수 모드"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--env-mode-option",
                children: _jsx(_components.code, {
                  children: "--env-mode"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#envmode",
                children: _jsx(_components.code, {
                  children: "envMode"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "벤더 환경 변수"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_ci_vendor_env_key",
                children: _jsx(_components.code, {
                  children: "TURBO_CI_VENDOR_ENV_KEY"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "프레임워크 변수 예외"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--framework-inference",
                children: _jsx(_components.code, {
                  children: "--framework-inference"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "디버깅-출력",
      children: "디버깅 출력"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "동작"
            }), _jsx(_components.th, {
              children: "플래그"
            }), _jsx(_components.th, {
              children: "환경 변수"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "실행 요약"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--summarize",
                children: _jsx(_components.code, {
                  children: "--summarize"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_run_summary",
                children: _jsx(_components.code, {
                  children: "TURBO_RUN_SUMMARY"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "그래프 시각화"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--graph-file-name",
                children: _jsx(_components.code, {
                  children: "--graph"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Dry run"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--dry----dry-run",
                children: _jsx(_components.code, {
                  children: "--dry"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "인증",
      children: "인증"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "동작"
            }), _jsx(_components.th, {
              children: "플래그"
            }), _jsx(_components.th, {
              children: "환경 변수"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "로그인 URL"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_login",
                children: _jsx(_components.code, {
                  children: "TURBO_LOGIN"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#loginurl",
                children: _jsx(_components.code, {
                  children: "remoteCache.loginUrl"
                })
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "팀 이름 (멀티 팀 Remote Cache용)"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--team",
                children: _jsx(_components.code, {
                  children: "--team"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_team",
                children: _jsx(_components.code, {
                  children: "TURBO_TEAM"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "팀 ID (멀티 팀 Remote Cache용)"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_teamid",
                children: _jsx(_components.code, {
                  children: "TURBO_TEAMID"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "인증 토큰"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/run#--token",
                children: _jsx(_components.code, {
                  children: "--token"
                })
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_token",
                children: _jsx(_components.code, {
                  children: "TURBO_TOKEN"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.h3, {
      id: "기타",
      children: "기타"
    }), "\n", _jsx("div", {
      className: "options-cheat-sheet-table",
      children: _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "동작"
            }), _jsx(_components.th, {
              children: "플래그"
            }), _jsx(_components.th, {
              children: "환경 변수"
            }), _jsx(_components.th, {
              children: "turbo.json"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "바이너리 경로"
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_binary_path",
                children: _jsx(_components.code, {
                  children: "TURBO_BINARY_PATH"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["로컬 ", _jsx(_components.code, {
                children: "turbo"
              }), " 다운로드"]
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/system-environment-variables#turbo_download_local_enabled",
                children: _jsx(_components.code, {
                  children: "TURBO_DOWNLOAD_LOCAL_ENABLED"
                })
              })
            }), _jsx(_components.td, {
              children: "-"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "데몬"
            }), _jsx(_components.td, {
              children: _jsxs(_components.a, {
                href: "/docs/reference/run#--daemon-and---no-daemon",
                children: [_jsx(_components.code, {
                  children: "--daemon"
                }), " / ", _jsx(_components.code, {
                  children: "--no-daemon"
                })]
              })
            }), _jsx(_components.td, {
              children: "-"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "/docs/reference/configuration#daemon",
                children: _jsx(_components.code, {
                  children: "daemon"
                })
              })
            })]
          })]
        })]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
